import { AxiosResponse } from "axios";
import { apiServiceV2 } from ".";

export interface PayDepositRequest {
	matchUuid: string;
	payerName: string;
	payerEmail: string;
	payerPhone: string;
	billingKey?: string;
}

export interface PayDepositResponse {
    isSuccess: boolean;
    transactionId?: string;
}

// 링크결제 관련 타입/함수 제거: 디파짓은 정기(빌링) 결제로 처리합니다.

export interface DepositStatusResponse {
	depositUuid?: string;
	matchUuid: string;
	depositAmount: number;
	depositStatus: string;
	dateDepositPaid?: Date;
	dateDepositRefunded?: Date;
	refundReason?: string;
}

export interface RefundDepositRequest {
	matchUuid: string;
	refundReason: string;
}

export interface RefundDepositResponse {
	isSuccess: boolean;
	refundTransactionId?: string;
}

export interface RefundableDepositsResponse {
	deposits: {
		depositUuid: string;
		matchUuid: string;
		depositAmount: number;
		depositStatus: string;
		dateDepositPaid: Date;
		companyName?: string;
		companyEmail?: string;
	}[];
}

/**
 * 디파짓 결제
 */
export const payDeposit = async (data: PayDepositRequest): Promise<PayDepositResponse> => {
    const response: AxiosResponse<PayDepositResponse> = await apiServiceV2.post(
        "/match-deposit/pay",
        data,
    );
    return response.data;
};

// 링크결제 토큰/완료 기록 API 제거

/**
 * 디파짓 상태 조회
 */
export const getDepositStatus = async (matchUuid: string): Promise<DepositStatusResponse | null> => {
	const response: AxiosResponse<DepositStatusResponse | null> = await apiServiceV2.get(
		`/match-deposit/status/${matchUuid}`,
	);
	return response.data;
};

/**
 * 디파짓 필요 여부 확인
 */
export const isDepositRequired = async (matchUuid: string): Promise<{ isRequired: boolean; depositAmount: number }> => {
    const response: AxiosResponse<{ isRequired: boolean; depositAmount: number }> = await apiServiceV2.get(
        `/match-deposit/required/${matchUuid}`,
    );
    return {
        isRequired: response.data?.isRequired ?? false,
        depositAmount: response.data?.depositAmount ?? 100000,
    };
};

/**
 * 디파짓 환불 (관리자용)
 */
export const refundDeposit = async (data: RefundDepositRequest): Promise<RefundDepositResponse> => {
	const response: AxiosResponse<RefundDepositResponse> = await apiServiceV2.post(
		"/match-deposit/refund",
		data,
	);
	return response.data;
};

/**
 * 클라이언트용 디파짓 환불 (전문가 수락 시 자동 환불)
 */
export const refundDepositForClient = async (matchUuid: string): Promise<RefundDepositResponse> => {
	const response: AxiosResponse<RefundDepositResponse> = await apiServiceV2.post(
		"/match-deposit/refund-for-client",
		{ matchUuid },
	);
	return response.data;
};

/**
 * 환불 가능한 디파짓 목록 조회 (관리자용)
 */
export const getRefundableDeposits = async (): Promise<RefundableDepositsResponse> => {
	const response: AxiosResponse<RefundableDepositsResponse> = await apiServiceV2.get(
		"/match-deposit/refundable",
	);
	return response.data;
};

export const completeDepositPayment = async (data: {
	matchUuid: string;
	transactionId: string;
	payerName: string;
	matchedExpertDataUuid: string;
}): Promise<{ isSuccess: boolean }> => {
	const response: AxiosResponse<{ isSuccess: boolean }> = await apiServiceV2.post(
		"/match-deposit/complete",
		data,
	);
	return response.data;
};
